"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateVoucherRequestToJSON = exports.UpdateVoucherRequestFromJSONTyped = exports.UpdateVoucherRequestFromJSON = exports.instanceOfUpdateVoucherRequest = void 0;
var runtime_1 = require("../runtime");
var VoucherRewardType_1 = require("./VoucherRewardType");
var VoucherStatus_1 = require("./VoucherStatus");
/**
 * Check if a given object implements the UpdateVoucherRequest interface.
 */
function instanceOfUpdateVoucherRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfUpdateVoucherRequest = instanceOfUpdateVoucherRequest;
function UpdateVoucherRequestFromJSON(json) {
    return UpdateVoucherRequestFromJSONTyped(json, false);
}
exports.UpdateVoucherRequestFromJSON = UpdateVoucherRequestFromJSON;
function UpdateVoucherRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'claimedAt': !(0, runtime_1.exists)(json, 'claimedAt') ? undefined : (new Date(json['claimedAt'])),
        'expiresAt': !(0, runtime_1.exists)(json, 'expiresAt') ? undefined : (new Date(json['expiresAt'])),
        'participantId': !(0, runtime_1.exists)(json, 'participantId') ? undefined : json['participantId'],
        'participantEntryCount': !(0, runtime_1.exists)(json, 'participantEntryCount') ? undefined : json['participantEntryCount'],
        'participantName': !(0, runtime_1.exists)(json, 'participantName') ? undefined : json['participantName'],
        'rewardId': !(0, runtime_1.exists)(json, 'rewardId') ? undefined : json['rewardId'],
        'rewardName': !(0, runtime_1.exists)(json, 'rewardName') ? undefined : json['rewardName'],
        'rewardImageUrl': !(0, runtime_1.exists)(json, 'rewardImageUrl') ? undefined : json['rewardImageUrl'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (0, VoucherStatus_1.VoucherStatusFromJSON)(json['status']),
        'rewardType': !(0, runtime_1.exists)(json, 'rewardType') ? undefined : (0, VoucherRewardType_1.VoucherRewardTypeFromJSON)(json['rewardType']),
    };
}
exports.UpdateVoucherRequestFromJSONTyped = UpdateVoucherRequestFromJSONTyped;
function UpdateVoucherRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'claimedAt': value.claimedAt === undefined ? undefined : (value.claimedAt.toISOString()),
        'expiresAt': value.expiresAt === undefined ? undefined : (value.expiresAt.toISOString()),
        'participantId': value.participantId,
        'participantEntryCount': value.participantEntryCount,
        'participantName': value.participantName,
        'rewardId': value.rewardId,
        'rewardName': value.rewardName,
        'rewardImageUrl': value.rewardImageUrl,
        'status': (0, VoucherStatus_1.VoucherStatusToJSON)(value.status),
        'rewardType': (0, VoucherRewardType_1.VoucherRewardTypeToJSON)(value.rewardType),
    };
}
exports.UpdateVoucherRequestToJSON = UpdateVoucherRequestToJSON;
